import { AbstractControl, ValidatorFn } from '@angular/forms';

import { validateDNI } from '../dni/validator';
import { validateNIF } from '../nif/validator';

export const validateNIE = (value) => {
    const match = value.match(/^[MXYZ]\d{7,8}[A-Z]$/);

    if (match) {
        let prefix = value.charAt(0);

        switch (prefix) {
            case 'M':
                return validateNIF(value);
            case 'X':
                prefix = 0;
                break;
            case 'Y':
                prefix = 1;
                break;
            case 'Z':
                prefix = 2;
                break;
        }

        return validateDNI(prefix + value.substring(1));
    }

    return false;
};

export const nie = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } => {
        let v: string = control.value;

        if (!v) {
            return null;
        }

        v = v.toUpperCase().replace(/\s/, '');

        return validateNIE(v) ? null : { nie: true };
    };
};
